import React from "react";

interface LogoMarkProps extends React.SVGProps<SVGSVGElement> {}

// Inline SVG logo that adapts to currentColor (use Tailwind text-* to color it)
const LogoMark: React.FC<LogoMarkProps> = ({ className, ...props }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="US Height Percentiles logo"
      className={className}
      {...props}
    >
      {/* Ruler body */}
      <rect x="5" y="3" width="6" height="18" rx="2" ry="2" fill="currentColor" opacity="0.12" />

      {/* Tick marks */}
      <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
        <line x1="6.5" y1="6" x2="9.5" y2="6" />
        <line x1="6.5" y1="9" x2="8.8" y2="9" />
        <line x1="6.5" y1="12" x2="9.5" y2="12" />
        <line x1="6.5" y1="15" x2="8.8" y2="15" />
        <line x1="6.5" y1="18" x2="9.5" y2="18" />
      </g>

      {/* Percentile marker (dot) */}
      <circle cx="16.5" cy="7" r="2.25" fill="currentColor" />

      {/* Subtle emphasis line */}
      <line x1="13.5" y1="7" x2="11.2" y2="7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export default LogoMark;
